import { useEffect } from "react";

const SCREENER_MANIFEST_HREF = "/screener-manifest.json";
const APPLE_TOUCH_ICON_HREF = "/screener-icon-180.png";

const APPLE_META: ReadonlyArray<readonly [string, string]> = [
  ["apple-mobile-web-app-capable", "yes"],
  ["apple-mobile-web-app-title", "Manatee Screener"]
];

function addMetaIfMissing(name: string, content: string): HTMLMetaElement | null {
  if (document.querySelector(`meta[name="${name}"]`)) {
    return null;
  }
  const meta = document.createElement("meta");
  meta.name = name;
  meta.content = content;
  document.head.appendChild(meta);
  return meta;
}

function addAppleTouchIconIfMissing(): HTMLLinkElement | null {
  if (document.querySelector('link[rel="apple-touch-icon"]')) {
    return null;
  }
  const link = document.createElement("link");
  link.rel = "apple-touch-icon";
  link.setAttribute("sizes", "180x180");
  link.href = APPLE_TOUCH_ICON_HREF;
  document.head.appendChild(link);
  return link;
}

export default function useScreenerInstallManifest(): void {
  useEffect(() => {
    const manifestLink = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    const previousHref = manifestLink?.getAttribute("href") ?? null;
    manifestLink?.setAttribute("href", SCREENER_MANIFEST_HREF);

    const addedMeta = APPLE_META.map(([name, content]) => addMetaIfMissing(name, content)).filter(
      (meta): meta is HTMLMetaElement => meta !== null
    );
    const addedIcon = addAppleTouchIconIfMissing();

    return () => {
      if (manifestLink && previousHref !== null) {
        manifestLink.setAttribute("href", previousHref);
      }
      addedMeta.forEach(meta => meta.remove());
      addedIcon?.remove();
    };
  }, []);
}
